import { InvitationFeature } from "@modules/auth/features/invitation/Invitation.feature";

export const InvitationPage = () => {
  return <InvitationFeature />;
};
